import {
  INFO_TEXT_CURRENT_RISK,
  INFO_TEXT_POPULATION_AVERAGE_RISK,
  INFO_TEXT_POTENTIAL_RISK,
} from '@/constants/info-text';
import { formatRiskDecimal } from '@/utils';
import { Box, Flex, Text } from '@cmpsr/components';
import { InfoPopover } from '../info-popover/info-popover';
import { colorFromRisk } from '@/utils/cancer/risk/color-from-risk';
type RiskSummaryProps = {
  currentRisk: number;
  potentialRisk: number;
  average: number;
  cancerType: string;
};

const RiskSummary = ({ currentRisk, potentialRisk, average, cancerType }: RiskSummaryProps) => {
  return (
    <Flex direction="row" gap="spacer-4" width="100%">
      <Flex direction="column" gap="spacer-2" flex="1">
        <Box
          height={{ base: '35px', md: '45px' }}
          borderRadius="radii-2"
          alignItems="center"
          justifyContent="center"
          display="flex"
          {...colorFromRisk(currentRisk, average)}
        >
          <Text variant={{ base: 'text-body-medium', md: 'text-body-display-XS' }}>
            {formatRiskDecimal(currentRisk, cancerType)}
          </Text>
        </Box>
        <Text variant="text-body-floating-label-regular">Current Lifetime Risk</Text>
        <InfoPopover popoverContent={INFO_TEXT_CURRENT_RISK} color="primary-default" iconSize="s" placement="bottom" />
      </Flex>
      <Flex direction="column" gap="spacer-2" flex="1">
        <Box
          height={{ base: '35px', md: '45px' }}
          backgroundColor="primary-default"
          borderRadius="radii-2"
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <Text variant={{ base: 'text-body-medium', md: 'text-body-display-XS' }} color="white">
            {formatRiskDecimal(potentialRisk, cancerType)}
          </Text>
        </Box>
        <Text variant="text-body-floating-label-regular">Potential Risk</Text>
        <InfoPopover
          popoverContent={INFO_TEXT_POTENTIAL_RISK}
          color="primary-default"
          iconSize="s"
          placement="bottom"
        />
      </Flex>
      <Flex direction="column" gap="spacer-2" flex="1">
        <Box
          height={{ base: '35px', md: '45px' }}
          backgroundColor="tan"
          borderRadius="radii-2"
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <Text variant={{ base: 'text-body-medium', md: 'text-body-display-XS' }} color="black">
            {formatRiskDecimal(average, cancerType)}
          </Text>
        </Box>
        <Text variant="text-body-floating-label-regular">Population Average</Text>
        <InfoPopover
          popoverContent={INFO_TEXT_POPULATION_AVERAGE_RISK}
          color="primary-default"
          iconSize="s"
          placement="bottom"
        />
      </Flex>
    </Flex>
  );
};

export default RiskSummary;
